export function isEmpty(data: any): boolean {
  return data === null || data === undefined || data === '' || +data === 0;
}

const dotKeys = [110, 190, 191];
const extraChars = [35, 36, 37, 39, 46, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105];
const digitKeys = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105];
const dashKeys = [109, 189];
const unidentified = 229; //dot and comma on Android

export function decimalOnly(event: any): boolean {
  if (event.ctrlKey || event.metaKey)
    return true;

  const inputValue = event.target.value;
  const charCode = (event.which) ? event.which : event.keyCode;

  if (['.', ','].includes(event.key) || charCode === unidentified) {
    const [start, end] = [event.target.selectionStart, event.target.selectionEnd];
    if (!inputValue || end - start === inputValue.length) {
      event.target.value = '0';
      return true;
    }

    if (inputValue.includes('.') && !inputValue.slice(start, end).includes('.'))
      return false;
  }

  if (event.shiftKey && digitKeys.includes(charCode))
    return false;

  if (/\d|\.|\,/.test(event.key) || charCode === unidentified)
    return true;

  if (dotKeys.includes(charCode))
    return false;

  return !(
    charCode > 31
    && (charCode <= 46 || charCode > 57)
    && !extraChars.includes(charCode)
  );
}

export function digitsOnly(event: any): boolean {
  if (event.ctrlKey || event.metaKey)
    return true;

  const charCode = (event.which) ? event.which : event.keyCode;

  if (event.shiftKey && digitKeys.includes(charCode))
    return false;

  if (/\d/.test(event.key))
    return true;

  return !(
    charCode > 31
    && (charCode <= 46 || charCode > 57)
    && !extraChars.includes(charCode)
  );
}

export function digitsAndDash(event: any) {
  if (event.ctrlKey || event.metaKey)
      return true;
  
    const charCode = (event.which) ? event.which : event.keyCode;

    if (event.shiftKey && digitKeys.includes(charCode))
      return false;

    if (event.key === '-') {
      const inputValue = event.target.value;
      if (!inputValue)
        return false;

      const [start, end] = [event.target.selectionStart, event.target.selectionEnd];
      if (!start || end - start === inputValue.length)
        return false;

      if (inputValue[start - 1] === '-' || inputValue[end] === '-')
        return false;

      return true;
    }

    if (/\d/.test(event.key))
      return true;

    return !(
      charCode > 31
      && (charCode <= 46 || charCode > 57)
      && !extraChars.includes(charCode)
  );
}

export function onDecimalPaste(event: ClipboardEvent) {
  return !!event.clipboardData?.getData('text').match(/^\d+\.?\d*$/);
}

export function onIntegerPaste(event: ClipboardEvent) {
  return !!event.clipboardData?.getData('text').match(/^\d+$/);
}

export function onDigitsAndDashPaste(event: ClipboardEvent) {
  return !!event.clipboardData?.getData('text').match(/^\d(?:-?\d)*$/);
}